export default "__VITE_ASSET__tXKHLKJ2__"